import { FiGrid, FiList } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setViewMode } from "../../../store/slices/mediaSlice";
import type { ViewMode } from "../../../store/slices/mediaSlice";

export function ViewToggle() {
  const dispatch = useAppDispatch();
  const viewMode = useAppSelector((state) => state.media.viewMode);

  const handleViewChange = (mode: ViewMode) => {
    dispatch(setViewMode(mode));
  };

  return (
    <div className="inline-flex rounded-md shadow-sm" role="group" aria-label="View mode">
      <button
        type="button"
        onClick={() => handleViewChange("grid")}
        className={`${
          viewMode === "grid" ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"
        } rounded-l-md border border-gray-300 px-3 py-2 text-sm font-medium transition-colors focus:z-10 focus:outline-none focus:ring-2 focus:ring-blue-500`}
        aria-label="Grid view"
        aria-pressed={viewMode === "grid"}
      >
        <FiGrid className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => handleViewChange("list")}
        className={`${
          viewMode === "list" ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"
        } -ml-px rounded-r-md border border-gray-300 px-3 py-2 text-sm font-medium transition-colors focus:z-10 focus:outline-none focus:ring-2 focus:ring-blue-500`}
        aria-label="List view"
        aria-pressed={viewMode === "list"}
      >
        <FiList className="h-4 w-4" />
      </button>
    </div>
  );
}
